<template>
  <div>
    <div class="thumbs-bg-fix"></div>
    <div class="issue-thumbs">
      <div
        v-for="(page, index) in $props.pages"
        :key="index"
        class="thumb"
        @click.prevent="goToPage(page)"
      >
        <!-- <v-img :src="page.fullThumbnailPath" class="thumb-img" ></v-img> -->
        <img v-lazy="page.fullThumbnailPath + 'as'" />
        <span
          :class="{
            active: parseInt($route.params.pageNumber) === page.pageNumber
          }"
          >{{ index + 1 }}</span
        >
      </div>
    </div>
    <footer class="thumb-footer">
      <span class="text">
        <b>{{ parseInt($route.params.pageNumber) + 1 }}</b> de
        <b>{{ $props.pages.length }}</b></span
      >
      <v-btn color="primary" @click.prevent="closeThumbs()">Fechar</v-btn>
    </footer>
  </div>
</template>

<script>
import bus from '@/utils/bus';

export default {
  name: 'issue-thumbs',
  props: {
    pages: null,
    selectedPage: 0
  },
  data() {
    return {
      transition: 'slide-y-reverse-transition'
    };
  },
  methods: {
    closeThumbs() {
      bus.$emit('show-thumbs', false);
    },
    goToPage(page) {
      this.trackAnalytics('reader', 'clicar-thumb-leitor', 'comic-thumb-click');

      bus.$emit('show-thumbs', false);

      var type = 'EdicaoImage';
      if (window.location.pathname.indexOf('video') >= 0) {
        type = 'EdicaoVideo';
      }

      this.$router.push({
        name: type,
        params: {
          issueId: this.$route.params.issueId,
          pageNumber: page.pageNumber
        }
      });
    },
    trackAnalytics(p1, p2, p3) {
      this.$ga.event(p1, p2, p3);
    }
  }
};
</script>

<style lang="scss">
@import '../assets/css/_variables';

img[lazy='loading'] {
  border: 2px solid #404040;
  min-height: 150px;
}
img[lazy='error'] {
  border: 5px solid red;
}
img[lazy='loaded'] {
  border: 2px solid transparent;
}

.issue-thumbs-container {
  position: relative;
  z-index: 999;

  .slide-in-left-enter-active {
    .thumb-footer {
      transform: translateY(70px);
    }
  }
}

.thumbs-bg-fix {
  background-color: rgba(black, 0.9);
  z-index: 1000;
  position: fixed;
  top: -500px;
  left: 0;
  right: 0;
  bottom: -500px;
}

.thumb-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  background-color: rgba(27, 27, 27, 0.97) !important;
  border-top: solid 1px #252525;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  height: calc(60px + env(safe-area-inset-bottom));
  padding-bottom: 5px;
  padding-bottom: calc(max(20px, env(safe-area-inset-bottom)));
  transition: all 0.3s ease;

  .text {
    color: white;
    padding: 10px;
    font-weight: lighter;
    b {
      font-weight: 400;
      font-size: 16px;
    }
  }
}
.issue-thumbs {
  z-index: 1000;
  position: relative;
  bottom: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-flow: row wrap;
  padding: 0;
  margin: 0;
  list-style: none;
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  padding-bottom: 80px;

  .thumb {
    width: calc(15% - 34px);
    @media only screen and (max-width: 1400px) {
      width: calc(15% - 30px);
    }
    @media only screen and (max-width: 600px) {
      width: calc(33% - 20px);
      max-width: calc(33% - 20px);
    }
    // margin: 30px 10px auto;
    margin: 10px auto;

    height: auto;
    flex-direction: row;
    // flex: 1 1 auto;
    text-align: center;
    justify-content: center;
    position: relative;
    transition: all 0.3s ease;
    cursor: pointer;
    &:after {
      content: '';
      position: absolute;
      bottom: 4px;
      left: 0;
      right: 0;
      height: 30px;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.6) 30%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    &:hover {
      transform: scale(1.1);
    }
    span {
      pointer-events: none;
      position: absolute;
      bottom: 5px;
      height: 25px;
      width: 25px;
      background: white;
      border-radius: 50%;
      text-align: center;
      transform: translateX(-50%);
      left: 50%;
      color: $primary;
      font-size: 12px;
      line-height: 24px;
      display: inline-block;
      border: solid 1px $primary;
      z-index: 1;
      &.active {
        background: $primary;
        color: white;
      }
    }
  }
}
</style>
